<template>
  <div class="bbe-page-container">
    <transition name="bbe-fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <EmailSidebar/>
    <div class="bbe-page-container-right-panel" ref="rightPanel">
      <NewMailFullSize key="NewMailFullSize" v-if="newMessage.openFullSize" @setLoader="setLoader"/>
      <TemplateOpen key="TemplateOpen" v-else-if="newMessage.openTemplate" @setLoader="setLoader"/>
      <Email key="Email" v-else-if="!newMessage.openFullSize && activeEmail.id" @setLoader="setLoader"/>
      <PlaceholderRightPanel key="PlaceholderRightPanel" v-else/>
    </div>
    <transition name="bbe-routing-fade" appear>
      <NewMailPopUp v-if="newMessage.open"/>
    </transition>
    <transition name="bbe-routing-fade" appear>
      <SendingStatus v-if="newMessage.status === 'sent'"/>
    </transition>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import EmailSidebar from '@/components/Main/EmailSidebar/EmailSidebar'
import NewMailPopUp from '@/components/NewMail/NewMailPopUp/NewMailPopUp'
import NewMailFullSize from '@/components/NewMail/NewMailFullSize/NewMailFullSize'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import setUserInfo from '@/mixin/setUserInfo'
import SendingStatus from '@/components/Main/SendingStatus/SendingStatus'
import { get } from 'lodash'
import Email from '@/containers/Email'
import TemplateOpen from '@/components/Templates/TemplateOpen/TemplateOpen'
import PlaceholderRightPanel from '@/components/Main/PlaceholderRightPanel/PlaceholderRightPanel'
import getConfigGapi from '@/mixin/getConfigGapi'
import checkUserEmail from '@/mixin/checkUserEmail'

export default {
  name: 'MainPage',
  mixins: [setUserInfo, getConfigGapi, checkUserEmail],
  components: {
    PlaceholderRightPanel,
    TemplateOpen,
    SendingStatus,
    EmailSidebar,
    VuePerfectScrollbar,
    NewMailPopUp,
    NewMailFullSize,
    LoaderFly,
    Email
  },
  data () {
    return {
      loaderRun: false
    }
  },
  computed: {
    massMailing () {
      return this.$store.getters.emailStore
    },
    activeEmail: {
      get () {
        return this.$store.getters.activeEmail
      },
      set (data) {
        this.$store.dispatch('setActiveEmail', data)
      }
    },
    newMessage () {
      return this.$store.getters.newMessage
    }
  },
  methods: {
    setLoader (val) {
      this.loaderRun = val
    },
    checkMassMailing () {
      const paramMailing = get(this.$route, 'params.massMailing', false)
      if (!this.massMailing) return
      const openFullSize = paramMailing || this.massMailing.length > 0
      if (openFullSize) this.activeEmail = {}
      this.$set(this.newMessage, 'openFullSize', openFullSize)
    }
  },
  watch: {
    activeUser () {
      this.checkMassMailing()
    }
  },
  beforeMount () {
    this.checkMassMailing()
  }
}
</script>

<style lang="scss">
  @import "sass/style";

  .bbe-page-container {
    [class*="gmail"] {
      box-sizing: content-box;
    }

    strong {
      font-weight: bold;
    }

    em {
      font-style: italic;
    }

    u {
      text-decoration: underline;
    }

    ul {
      list-style-type: disc;
      list-style-position: inside;
    }

    ol {
      list-style-type: decimal;
      list-style-position: inside;
    }
  }

</style>

<style lang="scss" scoped>
  @import "sass/variables";
  @import "sass/mixins";

  .bbe-page-container {
    @include global-font;
    position: relative;
    background-color: $color-wild-sand;
    display: flex;
    margin: -40px -50px;

    @media (max-width: 1440px) {
      margin: -40px -30px;
    }

    &-right-panel {
      height: calc(100vh - 40px);
      width: calc(100vw - 605px);
      background-color: $color-white;
      margin: auto 20px;
      border-radius: 6px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/MainPage.vue